var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{attrs:{"label":_vm.$t('components.matomoConsent.label'),"disabled":_vm.disabled},on:{"click":_vm.switchConsent},model:{value:(_vm.refused),callback:function ($$v) {_vm.refused=$$v},expression:"refused"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }